<script setup>
const props = defineProps({
    color: {
        type: String,
        default: "black",
    },
    strokeWidth: {
        type: Number,
        default: 2.5,
    },
});
</script>

<template>
    <svg
        class="h-full w-full"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M19.5 12H3.5"
            :stroke="color"
            :stroke-width="strokeWidth"
            stroke-linecap="round"
        />
        <path
            d="M15 6L20.1161 11.1161C20.6043 11.6043 20.6043 12.3957 20.1161 12.8839L15 18"
            :stroke="color"
            :stroke-width="strokeWidth"
            stroke-linecap="round"
        />
    </svg>
</template>
